import getStickySession from 'utils/getStickySession';
import { GetRegion } from 'constants.js';
import htmlDecode from 'utils/htmlDecode';
import Utils from 'utils/Utils';
import { getHKS } from '../../utils/HKS';
import { getBrowser } from 'utils/Platform';

class AbstractRequestTask {
  success(data, b) {
    if (data.errors || !data.response) {
      return false;
    }

    return true;
  }

  error(err, b) {
    let json = {};
    try {
      json = (err && err.responseJSON) || JSON.parse(e.responseText);
    } catch (e) {}

    return this.reject(this.request.parseErrors(json));
  }

  parseErrors(completeError) {
    let message;

    if (completeError.errors) {
      if (typeof completeError.errors === 'string') {
        message = completeError.errors;
      } else if (completeError.errors.msg) {
        message = completeError.errors.msg;
      } else if (Array.isArray(completeError.errors)) {
        message = completeError.errors[0].message;
      } else if (Array.isArray(completeError.errors.error)) {
        message = completeError.errors.error[0];
      } else {
        message = completeError.errors.error;
      }
    } else {
      message = null;
    }

    try {
      message = htmlDecode(message);
    } catch (e) {}

    return { message, completeError };
  }

  getParams(config = window.getConfig) {
    const params = {
      api_version: config.api_version,
      authpn: config.authpn,
      authpt: config.authpt,
      format: 'json',
      region: GetRegion(),
      device_id: 'web',
      device_category: 'web',
      device_model: 'web',
      device_type: 'web',
      device_so: getBrowser(),
      device_manufacturer: 'generic',
      HKS: getHKS(),
    };

    const stickySession = getStickySession();

    return { ...params, ...this.params, ...stickySession };
  }

  getMethod() {
    return 'GET';
  }

  getUrl() {
    return this.url;
  }

  getHeaders() {
    return {};
  }

  setConfig(config) {
    this.config = config;
    return this;
  }

  setParams(params) {
    this.params = { ...this.getParams(), ...params };
    return this;
  }

  setUrl(endpoint) {
    const domain = this.config.url_dominio_microfwk;
    this.url = `${domain}${endpoint}`;
    return this;
  }
}

export default AbstractRequestTask;
